import { useEffect, useRef } from "react";

/**
 * Declarative setInterval hook. Calls `callback` every `delayMs` milliseconds.
 * Pass `null` for `delayMs` to pause.
 */
export function useInterval(callback: () => void, delayMs: number | null): void {
  const savedCallback = useRef(callback);

  useEffect(() => {
    savedCallback.current = callback;
  }, [callback]);

  useEffect(() => {
    if (delayMs === null || delayMs <= 0) return;
    const id = setInterval(() => savedCallback.current(), delayMs);
    return () => clearInterval(id);
  }, [delayMs]);
}
